import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';

  var dataJson;
  var _memory;
  var TargetingMapping = {
    abandon: 'abandon',
    percentage: 'kampyleInvitePercentageUsers',
    timeInSession: 'kampyleTimeInSession',
    timeOnPage: 'kampyleTimeOnPage',
    deviceTypes: 'devicetypes',
    pageEvents: 'pageElementEvent',
  };

  var featureToPathMapping = {
    'GTM': 'isGoogleAnalyticsClientGTM',
    'WCAG': 'isWCAG',
    'SPA': 'isSpa',
    'MANUALLY_INVITE_TARGETING' : 'isManuallyInviteTargeting',
    'CUSTOM_CSS_UPLOAD' : 'customCssUpload'
  };
  var supportedFeatures = [KAMPYLE_CONSTANT.FEATURE_FLAGS.EXEMPT_BUTTON_FORMS_FROM_QUARANTINE,
    KAMPYLE_CONSTANT.FEATURE_FLAGS.EXEMPT_EMBEDDED_FORMS_FROM_QUARANTINE,
    KAMPYLE_CONSTANT.FEATURE_FLAGS.EXEMPT_CODE_FORMS_FROM_QUARANTINE]


  var init = function () {
    dataJson = MDIGITAL_CONFIGURATION.getOnsiteConfiguration() || {};
    _memory = {};
  };

  function getNestedConfigurationProperty(propertyName){
    var configuration = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DATA_JSON);
    return KAMPYLE_UTILS.getNestedPropertyValue(configuration, propertyName);

  }

  function getShownFormId() {
    var allFormStates = getMemoryData('formsState') || {};
    for (var formId in allFormStates) {
      if (allFormStates.hasOwnProperty(formId)) {
        if (allFormStates[formId].shouldBeShown) {
          return formId;
        }
      }
    }

    return false;
  }

  function getAllShownForms() {
    var allFormsState = getMemoryData('formsState') || {};
    var shownForms = {};
    for (var formId in allFormsState) {
      if (allFormsState.hasOwnProperty(formId)) {
        if (allFormsState[formId].shouldBeShown || allFormsState[formId].shown) {
          shownForms[formId] = allFormsState[formId];
        }
      }
    }

    return shownForms;
  }

  function getDefaultFormState() {
    /**
     * TODO: improve mechanism, consider enums, update state in runtime.
     * (no need for all states to be reset with default values) @ydayan
     */
    return {
      loading: false,
      loaded: null,
      shouldBeShown: false,
      shown: false,
      inviteLoaded: null,
      inviteShown: false,
      jsonFailed: false,
      applicationFailed: false,
      isCurrentlySubmitted: false,
      /* Each targeting phase is filled with a set of rules. A rule is added to a phase once it is evaluated. */
      targeting: {
        pageTargeting: null, /* Not every form is targeted, so null represents that the rules for this forms were not even checked. */
        behavioralTargeting: [], /* This phase and the next one, only happens if the previous phase has passed.
                The phases are initialized with an empty array because if a form is targeted it necessarily will go through these phases. */
        quarantineTargeting: []
      }
    };
  }

  function initOnsiteDefaultState(formIdToReset) {
    var shouldResetAllForms = isNaN(formIdToReset) || !formIdToReset;
    var formsState;

    if (shouldResetAllForms) {
      formsState = {};
      var allData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration() || {};
      var allForms = allData.formNodes || [];
      var len = allForms.length;
      var curr;
      for (var i = 0; i < len; i++) {
        curr = allForms[i];
        if (curr) {
          formsState[curr.formId] = getDefaultFormState();
        }
      }
      setMemoryData('formsState', formsState);
    } else {
      formsState = KAMPYLE_DATA.getMemoryData('formsState');
      formsState[formIdToReset] = getDefaultFormState();
      setMemoryData('formsState', formsState);
    }

    setMemoryData('hostingElementsHeights', {});
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.IS_BUTTON_CONTAINER_CREATED, false);
    KAMPYLE_DATA.clearAllTimeoutHandlers(); /* Mainly for SPA - clear all existing timeout in case we switched pages in the middle of a process*/
    KAMPYLE_DATA.clearAllDOMEventsHandlers();
  }

  function clearAllTimeoutHandlers() {
    var allHandlers = getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.TIMEOUT_HANDLERS);

    for (var handlerKey in allHandlers) {
      window.clearTimeout(allHandlers[handlerKey]);
    }

    setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.TIMEOUT_HANDLERS, {});
  }

  function setTimeoutHandler(key, timeoutHandler) {
    setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.TIMEOUT_HANDLERS + "." + key, timeoutHandler);
  }

  function getTimeoutHandler(key) {
    return getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.TIMEOUT_HANDLERS + "." + key);
  }

  function setDOMEventHandler(key, eventName, eventHandler, targetElement) {
    var dataValue = {
      eventName: eventName,
      eventHandler: eventHandler,
      targetElement: targetElement
    }
    setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DOM_EVENT_HANDLERS + '.' + key, dataValue);
  }

  function getDOMEventHandler(key) {
    return getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DOM_EVENT_HANDLERS + "." + key);
  }

  function clearAllDOMEventsHandlers() {
    var handlers = getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DOM_EVENT_HANDLERS) || {};
    for (var key in handlers) {
      var eventName = handlers[key].eventName;
      var eventHandler = handlers[key].eventHandler;
      var targetElement = handlers[key].targetElement || document;
      targetElement.removeEventListener(eventName, eventHandler)
    }
    deleteMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DOM_EVENT_HANDLERS);
  }

  function setAuthorizationToken(jwt) {
    setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.EX_AUTHORIZATION_TOKEN, jwt);
  }

  function getAuthorizationToken() {
    return getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.EX_AUTHORIZATION_TOKEN);
  }

  function isFeatureEnabled(featureName) { //Add flags from dataJson you wish to support or to supportFeatures list
    var path = featureToPathMapping[featureName];
    if (path == null && supportedFeatures.indexOf(featureName) !== -1) {
      path = featureName
    }
    return !!path && !!KAMPYLE_UTILS.getNestedPropertyValue(dataJson, path);
  }

  function getData(dataName) {
    try {
      if(KAMPYLE_DATA.getPropertySharedSubdomain()) {
        return KAMPYLE_UTILS.kampyleGetCookie(KAMPYLE_UTILS.TOP_LEVEL_DOMAIN_COOKIE_PREFIX + dataName);
      }
      return localStorage[dataName] || KAMPYLE_UTILS.kampyleGetCookie(dataName);
    }
    catch(e) { //In case local storage is not available
      return KAMPYLE_UTILS.kampyleGetCookie(dataName);
    }
  }

  function getMemoryData(dataName) {
    dataName = dataName || '';
    return KAMPYLE_UTILS.getNestedPropertyValue(_memory, dataName);
  }

  function setMemoryData(dataName, dataValue) {
    KAMPYLE_UTILS.setNestedPropertyValue(_memory, dataName, dataValue);
  }

  function deleteMemoryData(dataName) {
    delete (_memory || {})[dataName];
  }


  function setData(dataName, dataValue, expriration) {
    var isCookieStorageDisabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DISABLE_COOKIE_STORAGE);
    if(isCookieStorageDisabled){
        if(!KAMPYLE_DATA.getPropertySharedSubdomain()) {
          try {
            localStorage[dataName] = dataValue;
          }
          catch (e) { //In case local storage is not available
            KAMPYLE_UTILS.kampyleSetCookie(dataName, dataValue, expriration || getCookieExpiration(), KAMPYLE_DATA.getPropertySharedSubdomain());
          }
      }
      else {
        KAMPYLE_UTILS.kampyleSetCookie(dataName, dataValue, expriration || getCookieExpiration(), KAMPYLE_DATA.getPropertySharedSubdomain());
      }
    } else {
      if(!KAMPYLE_DATA.getPropertySharedSubdomain()) {
        try {
          localStorage[dataName] = dataValue;
        }
        catch (e) { //In case local storage is not available
        }
      }
      KAMPYLE_UTILS.kampyleSetCookie(dataName, dataValue, expriration || getCookieExpiration(), KAMPYLE_DATA.getPropertySharedSubdomain());
    }

    return true;
  }
  var deleteData = function(dataName) {
    var propertySharedSubdomain = KAMPYLE_DATA.getPropertySharedSubdomain();
    if(propertySharedSubdomain){
      KAMPYLE_UTILS.kampyleDeleteCookie(KAMPYLE_UTILS.TOP_LEVEL_DOMAIN_COOKIE_PREFIX + dataName, propertySharedSubdomain);
      return;
    }
    try {
      if (localStorage[dataName] !== undefined) {
        delete localStorage[dataName];
      }
    }
    catch (e) { //In case local storage is not available
    }
    if (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DISABLE_COOKIE_STORAGE)) {
      KAMPYLE_UTILS.kampyleDeleteCookie(dataName);
    }
  };

  function getFormData(formId) {

    var allForms = getAllForms();

    var len = allForms.length, curr;
    for (var i = 0; i < len; i++ ) {
      curr = allForms[i];
      if (parseInt(formId) === parseInt(curr.formId)) {
        return curr;
      }
    }

    return null;
  }

  function getFormDataByUuid(formUuid) {
    var allForms = getAllForms();

    var len = allForms.length, curr;
    for (var i = 0; i < len; i++ ) {
      curr = allForms[i];
      if (curr.formUuid === formUuid) {
        return curr;
      }
    }

    return null;
  }

  function getMemory() {
    return _memory;
  }

  function getFormState(formId) {
    formId = formId || '';
    return getMemoryData('formsState.'+formId) || null;
  }


  function setFormState(formId, data) {
    data = data || {};
    var allFormState = getMemoryData('formsState') || {};
    allFormState[formId] = allFormState[formId] || {};

    for (var prop in data) {
      if(typeof allFormState[formId][prop] === "object" && allFormState[formId][prop] !== null){
        Object.assign(allFormState[formId][prop], data[prop]);
      }
      else {
        allFormState[formId][prop] = data[prop];
      }
    }

    setMemoryData('formsState',allFormState);
  }

  function getAllForms() {
    var allData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration() || {};
    var allForms = allData.formNodes || [];
    return allForms;
  }

  function getInegrations() {
    var allData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration() || {};
    return allData.integrations || {};
  }

  function getInviteData(formId) {
    var formData = getFormData(formId);
    return !!formData ? formData.inviteData : null;
  }

  function isNewMobileInvitation() {
    var hasProvision = KAMPYLE_FUNC.checkProvision('mobileInvitationLayout');
    var kampyleDevice = getMemoryData('kampyleDevice');
    return !!hasProvision && kampyleDevice !== 'desktop';
  }

  function isSkipInvitation(formId){
    var formData = getFormData(formId) || {};
    var isSkipInvitation = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'inviteData.skipInvitation')
    return isSkipInvitation && isSkipInvitation !== "false";
  }

  function isFixedSize(formId) {
		var formData = getFormData(formId) || {};
		return formData.isFixedSize === true || formData.isFixedSize === 'true';
	}

  function isCustomHtmlAndFixedSizeForm(formId) {
      var customHtmlForm = isCustomHtmlForm(formId);
      var hasProvision = KAMPYLE_FUNC.checkProvision('dynamicModalSizeInCustomHtml');
      return customHtmlForm && (!hasProvision || hasProvision && (isFixedSize(formId)));
	}

  function getDisplayType(formData) {
    var kampyleDevice = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var displayType = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'formDisplay.displayType');
    if (kampyleDevice !== KAMPYLE_CONSTANT.DEVICES.DESKTOP) {
      return displayType === KAMPYLE_CONSTANT.DISPLAY_TYPES.EMBEDDED ? KAMPYLE_CONSTANT.DISPLAY_TYPES.EMBEDDED : KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX;
    }
    else {
      return displayType || KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX;
    }
  }

  function saveFormExtraData(formId, extraData) {
    extraData = extraData || {};

    //Merge old extra data
    var oldExtraData = (getFormState(formId) || {}).pendingExtraData || {};
    extraData = Object.assign(oldExtraData, extraData);
    setFormState(formId, { pendingExtraData: extraData });
  }

  //Returns and deletes the extra data waiting to be sent
  function flushFormExtraData(formId) {
    var formState = getFormState(formId) || {};
    var extraData = {};

    if (formState && formState.pendingExtraData) {
      extraData = formState.pendingExtraData;
      delete formState.pendingExtraData;
    }

    return extraData;
  }

  function isCustomHtmlForm(formId) {
    var formData = getFormData(formId) || {};
    var isCustomHtml = KAMPYLE_UTILS.getUrlParam('isCustomHtml');
    return formData.isCustomHtmlEnabled === true || formData.isCustomHtmlEnabled === 'true' ||
           isCustomHtml === true || isCustomHtml === 'true';
  }

  function getCookieExpiration() {
    return  KAMPYLE_UTILS.getNestedPropertyValue(dataJson, 'cookieExpirationTime') ||
            KAMPYLE_CONSTANT.COOKIE_EXPIRATION;
  }

  function getTargetingData(formId, targetingName) {
    if (!formId || !targetingName || !TargetingMapping[targetingName]) {
      return null;
    }

    var selectedForm = getFormData(formId) || {};
    var targetingRealName = TargetingMapping[targetingName];

    return KAMPYLE_UTILS.getNestedPropertyValue(selectedForm, 'onSiteData.' + targetingRealName);
  }

  function getFormVersion(formId) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    return Number((formData || {}).formVersion) || 0;
  }

  function getPropertyId() {
    return MDIGITAL_CONFIGURATION.getOnsiteConfiguration().websiteId || null;
  }

  function isMobileDynamicSizing(formId) {
    var device = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var requiredVersion = KAMPYLE_CONSTANT.FEATURE_VERSIONS.MOBILE_DYNAMIC_SIZING;
    formId = formId || KAMPYLE_DATA.getMemoryData('currentFormId');
    var isCustomHtml = KAMPYLE_DATA.isCustomHtmlForm(formId);
    var isProvisioned = (
      (isCustomHtml && KAMPYLE_FUNC.checkProvision('mobileWebDynamicFormSize')) || // mobileWebDynamicFormSize Provision relevant to customHtml only
      (!isCustomHtml && KAMPYLE_FUNC.checkProvision('mobileWebDynamicFormSizeInFormBuilder'))
    );
    return isProvisioned &&
           (device && device !== 'desktop') &&
           !KAMPYLE_DATA.isV2Form(formId) &&
           KAMPYLE_DATA.getFormVersion(formId) >= requiredVersion;
  }

  function isMobile(){
    var device = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    return (device && device !== 'desktop');
  }

  function getServerBasedTargetingPrefix() {
    return getNestedConfigurationProperty('sbtServerDomain');
  }

    function getServerBasedTargetingEnv() {
        return getNestedConfigurationProperty('sbtEnvPrefix');
    }

	function getPropertySharedSubdomain() {
		var sharedSubdomain = getNestedConfigurationProperty('sharedSubdomain');
		return sharedSubdomain && KAMPYLE_UTILS.isHostMatchesSubdomain(window.location.host, sharedSubdomain) ? sharedSubdomain : null;
	}

  function getUserIdentifier() {
    var allCustomParams = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().customParams || [];
    var formNodes = KAMPYLE_DATA.getNestedConfigurationProperty('formNodes') || [];
    for (var i = 0; i < formNodes.length; i++) {
      var formCp = (formNodes[i].customParams || []).map((cpId) => allCustomParams.find(cp => cp.id === cpId));
      var identifierCp = (formCp || []).find((cp) => typeof(cp) === 'object' && cp.is_identifier === true ) || null;
      if (identifierCp !== null) {
        return identifierCp;
      }
    }
    return null;
  }

  function isPopupDisplayType(formId){
    var formData = getFormData(formId);
    return getDisplayType(formData) === KAMPYLE_CONSTANT.DISPLAY_TYPES.POPUP;
  }

  function isEmbeddedDisplayType(formId){
    var formData = getFormData(formId);
    return getDisplayType(formData) === KAMPYLE_CONSTANT.DISPLAY_TYPES.EMBEDDED;
  }

  function isLightBoxDisplayType(formId){
    var formData = getFormData(formId);
    return getDisplayType(formData) === KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX;
  }

  function getMemoryJsonKey(formId,isInvite,dataKey){
    var jsonDataKey;
    if(!dataKey){
      jsonDataKey = (isInvite ? KAMPYLE_CONSTANT.INVITE_JSON_DATA_KEY_PREFIX : KAMPYLE_CONSTANT.FORM_JSON_DATA_KEY_PREFIX) + formId;
    }else{
      jsonDataKey = isInvite ? dataKey + formId + '_invite' : dataKey + formId;
    }
    return  jsonDataKey + '_' + MDIGITAL_LOCALIZATION.getFormLanguage(formId);
  }

  function getMemoryJsonNestedPropertyValue(formId, propertyName, isInvite) {
    var key = KAMPYLE_DATA.getMemoryJsonKey(formId, isInvite);
    var data = KAMPYLE_DATA.getMemoryData(key);
    return data != null ? KAMPYLE_UTILS.getNestedPropertyValue(data, propertyName) : null;
  }


  function localizeUrl(formId, url) {
    // in case the language wasn't detected -> return default
    var langCode = MDIGITAL_LOCALIZATION.getFormLanguage(formId) || KAMPYLE_CONSTANT.LOCALIZED_FORM_DEFAULT_REPLACE_VALUE;
    return url.replace('###LANGUAGE_CODE###', langCode);
  }

  function resetAllFormsLanguagesCode(){
    var allForms = KAMPYLE_DATA.getAllForms();
    for(var i = 0; i < allForms.length; i++){
      var currForm = allForms[i];
        MDIGITAL_LOCALIZATION.detectAndSetFormLanguage(currForm);
      }
  }

  function getKeysByPrefix(prefix) {
    var keys = [];
    for (var key in localStorage) {
      if (key.indexOf(prefix) > -1) {
        keys.push(key);
      }
    }
    if (!KAMPYLE_DATA.getPropertySharedSubdomain() ||
        KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DISABLE_FIX_FOR_PARALLEL_TAB_SOLUTION)) {
      return keys;
    }
    var cookiePrefix = KAMPYLE_UTILS.TOP_LEVEL_DOMAIN_COOKIE_PREFIX + prefix;
    var tldPrefixLen = KAMPYLE_UTILS.TOP_LEVEL_DOMAIN_COOKIE_PREFIX.length;
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      var eqIndex = cookie.indexOf('=');
      if (eqIndex === -1) {
        continue;
      }
      var cookieName = cookie.substring(0, eqIndex);
      if (cookieName.indexOf(cookiePrefix) > -1) {
        keys.push(cookieName.substring(tldPrefixLen));
      }
    }
    return keys;
  }

  function clearSessionTabs(){
    var keys = getKeysByPrefix(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.SESSION_TAB_PREFIX);
    for (var i = 0; i < keys.length; i++) {
      KAMPYLE_DATA.deleteData(keys[i]);
    }
  }

  function getStorageDataByPrefix(prefix){
    var keys = getKeysByPrefix(prefix);
    var data = [];
    for (var i = 0; i < keys.length; i++) {
      data.push(KAMPYLE_DATA.getData(keys[i]));
    }
    return data;
  }

  function getDataJsonUrl(formId, isInviteJson) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    var jsonDataUrl = KAMPYLE_UTILS.getNestedPropertyValue(formData, isInviteJson ? 'inviteData.inviteDataUrl' : 'formDataUrl')
    if (!jsonDataUrl) { return null; }
    return KAMPYLE_DATA.localizeUrl(formId, jsonDataUrl);
  }

  function fetchFormJsonData(obj, isSecondCall) { //formId, callback, isInvite
    var jsonDataMemoryKey = KAMPYLE_DATA.getMemoryJsonKey(obj.formId,obj.isInvite);
    var jsonData = KAMPYLE_DATA.getMemoryData(jsonDataMemoryKey);
    var url = KAMPYLE_DATA.getDataJsonUrl(obj.formId, obj.isInvite);

    if (jsonData) {
      obj.fetchingDataInProgressKey && KAMPYLE_DATA.setMemoryData(obj.fetchingDataInProgressKey,false);
      return typeof obj.callback === "function" && obj.callback(jsonData);
    }

    if (!url) {
      var error = new Error("Failed to get JSON, jsonDataUrl is missing.");
      return typeof obj.onError === "function" && obj.onError(error);
    }

    KAMPYLE_UTILS.httpRequest(KAMPYLE_CONSTANT.HTTP_METHODS.GET, url, null, function(data) {
      if (isSecondCall) {
        var warnMessage = 'second http request have been made to the url: ' + url;
        KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_warning', { message: warnMessage });
      }

      if (!data) {
        var errorMessage = 'Invalid form json data. Data: ' + JSON.stringify(data);
        if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
          MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError({ errorMessage: errorMessage });
        }
        typeof obj.onError === "function" && obj.onError({ message: errorMessage });
      } else {
        KAMPYLE_DATA.setMemoryData(jsonDataMemoryKey, data);
        obj.fetchingDataInProgressKey && KAMPYLE_DATA.setMemoryData(obj.fetchingDataInProgressKey,false);
        typeof obj.callback === "function" && obj.callback(data);
      }

    }, function (error) {
      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
        MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError({ errorMessage: 'Failed to fetch JSON data. Error: ' + JSON.stringify(error)});
      }
      typeof obj.onError === "function" && obj.onError(error);
    });
  }

  function getFormTriggerType(formId) {
    var formType = KAMPYLE_UTILS.getNestedPropertyValue(KAMPYLE_DATA.getFormData(formId), 'formType');
    return KAMPYLE_CONSTANT.FORM_TRIGGER_TYPES_MAP[formType] ? formType : null;
  }

  function isFormOfType(formId, formType) {
    var dataFormType = getFormTriggerType(formId);
    return !!dataFormType && dataFormType === formType
  }

  //For forms without iframe like popup it returns null
  function getFormIframeId(formId) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    if (formData == null) return null;
    if (formData.formType === KAMPYLE_CONSTANT.FORM_TYPES.EMBEDDED){
      return KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + formId;
    }
    else {
      var displayType = KAMPYLE_DATA.getDisplayType(formData);
      if (displayType === KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX){
       return KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + formId;
      } else if (displayType === KAMPYLE_CONSTANT.DISPLAY_TYPES.ANIMATION) {
       return KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + formId;
      }
      else {
        return null;
      }
    }
  }

  function isV2Form(formId){
    var formData = KAMPYLE_DATA.getFormData(formId);
    if (!formId || !formData || !formData.formDataUrl) {return};

    return formData.formDataUrl.indexOf('formDataV2')>-1;
  }

  export default {
    init: init,
    isFeatureEnabled: isFeatureEnabled,
    getData: getData,
    setData: setData,
    deleteData: deleteData,
    getAllForms: getAllForms,
    getInegrations: getInegrations,
    getFormData: getFormData,
    getFormDataByUuid: getFormDataByUuid,
    getMemoryData: getMemoryData,
    getTargetingData: getTargetingData,
    setMemoryData: setMemoryData,
    getShownFormId: getShownFormId,
    getAllShownForms: getAllShownForms,
    getFormState: getFormState,
    setFormState: setFormState,
    getInviteData: getInviteData,
    getDisplayType: getDisplayType,
    saveFormExtraData: saveFormExtraData,
    flushFormExtraData: flushFormExtraData,
    isCustomHtmlForm: isCustomHtmlForm,
    getCookieExpiration: getCookieExpiration,
    isNewMobileInvitation: isNewMobileInvitation,
    isCustomHtmlAndFixedSizeForm: isCustomHtmlAndFixedSizeForm,
    deleteMemoryData: deleteMemoryData,
    getFormVersion: getFormVersion,
    isMobileDynamicSizing: isMobileDynamicSizing,
    getPropertySharedSubdomain: getPropertySharedSubdomain,
    getUserIdentifier: getUserIdentifier,
    getServerBasedTargetingPrefix: getServerBasedTargetingPrefix,
    getServerBasedTargetingEnv: getServerBasedTargetingEnv,
    isPopupDisplayType: isPopupDisplayType,
    isEmbeddedDisplayType: isEmbeddedDisplayType,
    isLightBoxDisplayType:isLightBoxDisplayType,
    fetchFormJsonData: fetchFormJsonData,
    getFormTriggerType: getFormTriggerType,
    getPropertyId: getPropertyId,
    isMobile: isMobile,
    isSkipInvitation:isSkipInvitation,
    getFormIframeId: getFormIframeId,
    isFormOfType:isFormOfType,
    getMemoryJsonNestedPropertyValue:getMemoryJsonNestedPropertyValue,
    resetAllFormsLanguagesCode: resetAllFormsLanguagesCode,
    getMemoryJsonKey:getMemoryJsonKey,
    clearSessionTabs:clearSessionTabs,
    getStorageDataByPrefix: getStorageDataByPrefix,
    setTimeoutHandler: setTimeoutHandler,
    getTimeoutHandler: getTimeoutHandler,
    isV2Form: isV2Form,
    setDOMEventHandler: setDOMEventHandler,
    getDOMEventHandler: getDOMEventHandler,
    clearAllDOMEventsHandlers: clearAllDOMEventsHandlers,
    setAuthorizationToken: setAuthorizationToken,
    getAuthorizationToken: getAuthorizationToken,

    // for testing
    localizeUrl: localizeUrl,
    getMemory: getMemory,
    initOnsiteDefaultState: initOnsiteDefaultState,
    getDataJsonUrl: getDataJsonUrl,
    clearAllTimeoutHandlers: clearAllTimeoutHandlers,
    getNestedConfigurationProperty: getNestedConfigurationProperty
  };

